export default __webpack_public_path__ + "static/media/bottom_purple_arrows.119fda43.svg";